import React, { useMemo } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import ContentBlock from 'components/ContentBlock'
import { Form, Text, Number as NumberField, Select, Checkbox } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import { loadAppConstants } from 'gql/query'
import { notEmpty } from 'helpers/validators'

const MWStEnums = ['normal', 'reduced', 'free', 'special']

const CashBook = ({ customData, newRecord, mutations }) => {
	const [t, i18n] = useTranslation()

	const taxRemoteOptions = useMemo(() => ({
		query: loadAppConstants,
		variables: { type: 33, language: i18n.language },
		modifyOptions: options => options.map(item => ({ ...item, value: MWStEnums[item.value - 1] }))
	}), [])

	const handleSubmit = vals => {
		if(newRecord) {
			mutations.createItem(vals)
		} else {
			mutations.updateItem(vals)
		}
	}

	return(
		<ContentBlock>
			<Form initialValues={ newRecord ? {} : customData || {}} onSubmit={handleSubmit} smartSubmit={!newRecord}>
				{({ formState }) => {
					const inactive = !formState.values.active
					return (
						<Row>
							<Col xs>
								<div>
									<Text
										field='description'
										label={t('options_section.fields.description')}
										{...notEmpty()}
										validateOnChange
										inline
									/>
									<Checkbox
										inline
										field='active'
										label={t('product_section.fields.active')}
									/>
								</div>
								<Text
									field='shouldAccount'
									label={t('options_section.fields.owe_account')}
									{...notEmpty()}
									validateOnChange
									disabled={inactive}
								/>
							</Col>
							<Col xs>
								<Select
									field='tax'
									remoteOptions={taxRemoteOptions}
									label={t('options_section.fields.tax')}
									shrink
									inline
									{...notEmpty()}
									validateOnChange
									disabled={inactive}
								/>
								<NumberField
									field='taxAmount'
									label={t('options_section.fields.tax_amount')}
									shrink
									withControls={false}
									inline
									disabled={inactive}
								/>
								<Select
									field='type'
									options={[
										{ value: 'income', label: t('options_section.strings.income') },
										{ value: 'outcome', label: t('options_section.strings.outcome') }
									]}
									label={t('common.fields.type')}
									{...notEmpty()}
									validateOnChange
									disabled={inactive}
								/>
							</Col>
							{newRecord &&
								<>
									<Divider />
									<Button type='submit' status='primary' text={t('common.buttons.create')} />
								</>
							}
						</Row>
					)
				}}
			</Form>
		</ContentBlock>
	)
}

export default CashBook
